import { render, staticRenderFns } from "./document-simple.vue?vue&type=template&id=6bc4e6b8&"
import script from "./document-simple.vue?vue&type=script&lang=js&"
export * from "./document-simple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bc4e6b8')) {
      api.createRecord('6bc4e6b8', component.options)
    } else {
      api.reload('6bc4e6b8', component.options)
    }
    module.hot.accept("./document-simple.vue?vue&type=template&id=6bc4e6b8&", function () {
      api.rerender('6bc4e6b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/document-simple.vue"
export default component.exports